<div class="buttons-wrapper {{Mode=='design' ? 'design-mode' : 'preview-mode'}}">
    <button mat-stroked-button color="primary" class="button" (click)="handleApply()">Apply</button>
    <button mat-stroked-button color="primary" class="button" (click)="handleClear()">Clear</button>
    @if (Mode=='design') {
    <div style="font-size:9pt;color:grey;">Note: Currently only one set of buttons is supported. Clicking Apply will send <em>all</em> flex field values to <em>all</em> Forms Grids.</div>
    }
    @if(IsShpFilteringEnabled && ShowSelectFilterOptionMsg) {
    <div class="warning button-message" data-grid-type="form-grid-unconfigured">
        Select filter option or leave blank and click apply to display records.
    </div>
    }
</div>
